import React, { FC } from 'react'
import { Modal, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.css'

interface Props {
  modalTitle: string;
  note: string;
  show: boolean;
  onClose: () => void;
}

const RejectionNoteModal: FC<Props> = ({ modalTitle, note, show, onClose }: Props) => (
  <Modal size='lg' show={show} onHide={onClose}>
    <Modal.Header closeButton id='modal-header'>
      <FontAwesomeIcon icon={['fas', 'info-circle']} size='lg' className='modal-header-icon' />
      <Modal.Title id='modal-header-title'>{modalTitle} - Note</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Card>
        <Card.Body className='rejection-note-card'>
          <span>Note</span>
          <Card className='rejection-note-white-card'>
            <Card.Body className='rejection-note-white-card-body'>
              {note}
            </Card.Body>
          </Card>
        </Card.Body>
      </Card>
    </Modal.Body>
  </Modal>
)

export default RejectionNoteModal